import * as React from 'react';
import {Header} from '.';

type Props = {
  header: React.ReactNode;
  children: React.ReactNode;
};

const Section = (props: Props) => {
  return (
    <div className="flex flex-col gap-1">
      <Header>{props.header}</Header>
      <div className="overflow-hidden rounded border border-border">{props.children}</div>
    </div>
  );
};

export default Section;
